import '@/styles/index.scss';

export { default } from '@/fragments/app';
